import { TreeItem, TreeItemIndex } from 'react-complex-tree'

import type { I18nShape } from '@tribeplatform/react-components/i18n'

import { ArchivedCMSRootTreeItem } from '../components/ArchivedCMSRootTreeItem.js'
import { SimpleTreeItemData } from '../types.js'

export const ARCHIVED_CMS_INDEX = 'archived-cms'

export function createArchivedCMSRootTreeItem(
  { $t }: I18nShape,
  {
    children,
  }: {
    children: TreeItemIndex[]
  },
): TreeItem<SimpleTreeItemData> {
  return {
    index: ARCHIVED_CMS_INDEX,
    isFolder: true,
    data: {
      type: 'simple',
      title: $t({
        id: 'Admin.CMS.Model.ArchivedModels',
        defaultMessage: 'Archived models',
      }) as string,
      render: () => <ArchivedCMSRootTreeItem />,
    },
    children,
  }
}
